/*
global Chartist
*/

(function ($, XTT) {
    'use strict';

    if ( $( '.chart-list' ).length ) {
      XTT.charts = {
        _autoload: [
            'handleChartEvents',
            'handleChartsInit'
        ],

        handleChartEvents: function() {
          $('.toggle-chart-info').on('click', XTT.charts.handleChartInfo);
        },

        handleChartInfo: function(e) {
          var $this = $(this);
          e.preventDefault();
          $this.toggleClass('open');
          $this.prev('.chart-description').toggleClass('open');
          if($this.hasClass('open')) {
            $this.text('Menos detalhes');
          } else {
            $this.text('Mais detalhes');
          }
        },

        handleChartsInit: function () {

          var option = {
            fullWidth: true,
            chartPadding: {
              right: 30,
              top: 30
            }
          };

          $.ajax({
            dataType: "json",
            url: XTT.config.fecomerciourl + '/wp-json/custom_api/v1/api-icec-chart',
            success: function(dados){
              new Chartist.Line('.ct-chart-icec', dados, option);
            }
          });

          $.ajax({
            dataType: "json",
            url: XTT.config.fecomerciourl + '/wp-json/custom_api/v1/api-icf-chart',
            success: function(dados){
              new Chartist.Line('.ct-chart-icf', dados, option);
            }
          });

          $.ajax({
            dataType: "json",
            url: XTT.config.fecomerciourl + '/wp-json/custom_api/v1/api-peic-chart',
            success: function(dados){
              new Chartist.Line('.ct-chart-peic', dados, option);
            }
          });

        }

      };

    }

})
(jQuery, XTT);